import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = async (newLang) => {
    await i18n.changeLanguage(newLang);
    const currentPath = window.location.pathname.replace(/^\/[a-z]{2}/, '');
    navigate(`/${newLang}${currentPath}`);
    window.location.reload(); // Müvəqqəti həll
  };

  // Helper for Capitalized format
  const formatLang = (langCode) => 
    `${langCode.slice(0, 1).toUpperCase()}${langCode.slice(1).toLowerCase()}`;

  return (
    <div className="relative inline-block text-left text-white">
      <div>
        <button
          type="button"
          className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium rounded-md focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {formatLang(i18n.language)}
          <svg
            className="w-4 h-4 ml-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.187l3.71-3.956a.75.75 0 011.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-2 w-24 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          <div className="py-1 text-black">
            <button
              onClick={() => handleLanguageChange("az")}
              className="block px-4 py-2 hover:bg-gray-100 w-full text-left"
            >
              Az
            </button>
            <button
              onClick={() => handleLanguageChange("en")}
              className="block px-4 py-2 hover:bg-gray-100 w-full text-left"
            >
              En
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
 